<template>
  <div class="d-flex w-100">
    <b-form class="w-100" @submit.stop.prevent="handleSave">
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Personal Details</h5>
        <b-form-row>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-input
              type="text"
              v-model="form.firstName"
              required
              placeholder="First Name"
            />
          </b-col>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-input
              type="text"
              v-model="form.lastName"
              required
              placeholder="Last Name"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-input
              type="text"
              v-model="form.phone"
              required
              placeholder="Phone"
            />
          </b-col>
          <b-col v-if="isAdmin" cols="12" xl="6" class="pb-2">
            <b-form-input
              type="email"
              v-model="form.email"
              required
              placeholder="Email"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-group
              label-cols="3"
              label-cols-md="2"
              label="DOB"
              label-for="dob"
              class="mb-0"
            >
              <b-form-input
                id="dob"
                v-model="form.DOB"
                type="date"
                size="sm"
                class="mb-2"
                cols="8"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="d-flex align-items-center">
          <p class="pr-3">Notification Method:</p>
          <b-form-radio-group v-model="form.notificationMethod" >
            <b-form-radio value="Text">Text</b-form-radio>
            <b-form-radio value="Email">Email</b-form-radio>
          </b-form-radio-group>
        </b-form-row>
      </div>
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Address</h5>
        <b-form-row>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-input
              type="text"
              v-model="form.address.address_line1"
              placeholder="Street"
            />
          </b-col>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-input
              type="text"
              v-model="form.address.address_line2"
              placeholder="Street (line 2)"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-input
              type="text"
              v-model="form.address.city"
              placeholder="City"
            />
          </b-col>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-group class="mb-0" size="sm">
              <select
                v-model="selectedState"
                class="form-control py-1"
                size="sm"
              >
                <option :key="0" :value="null">Select a State</option>
                <option v-for="(state, index) in states" :key="index + 1" :value="state">
                  {{ state }}
                </option>
              </select>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-input
              type="text"
              v-model="form.address.zip"
              placeholder="Zipcode"
            />
          </b-col>
        </b-form-row>
      </div>
      <div v-if="!myAccount" class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Groups</h5>
        <UserAccountGroupForm :activeGroups="newGroups" :groups="groups.data" v-on:handleAdd="handleGroupAdd" v-on:handleRemove="handleGroupRemove"/>
      </div>
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Parent(s) / Guardian(s)</h5>
        <div class="mb-3">
          <div v-for="(parent, index) in form.parents" class="spnod-admin__account--block" :key="index">
            {{ parent.name }} <button class="text-danger" @click="handleRemove(index)">X</button>
          </div>
        </div>
        <ParentFormBasic v-for="(parent, index) in newParents" :key="index" :parent="parent"/>
        <b-button @click="addParent" size="sm">
          <p v-if="newParents.length === 0">Add Parent/Guardian</p>
          <p v-else>Add Additional Parent/Guardian</p>
        </b-button>
      </div>
      <div class="spnod-admin__account--section" v-if="displayNutritionist">
        <h5 class="spnod-admin__account--header">Nutritionist</h5>
        <b-form-row>
          <b-col cols="12" xl="6" class="pb-2">
            <b-form-group class="mb-0" size="sm">
              <select
                v-model="selectedNutritionist"
                class="form-control py-1"
                size="sm"
              >
                <option v-for="(nutritionist, index) in dietitians.data" :key="index" :value="nutritionist._id">
                  {{ nutritionist.name }}
                </option>
              </select>
            </b-form-group>
          </b-col>
        </b-form-row>
      </div>
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Dietary Restrictions</h5>
        <b-textarea placeholder="Add your dietary restrictions here" v-model="form.dietaryRequirements" />
      </div>
      <div>
        <b-button class="spnod-admin__form--button" @click="handleSave" size="sm">
          <p v-if="!isSending">Save</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
        <b-button class="bg-danger" @click="$emit('handleCancel')" size="sm">Cancel</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ParentFormBasic from '../Forms/ParentFormBasic'
import UserAccountGroupForm from './UserAccountGroupForm'
import moment from 'moment'

export default {
  name: 'UserAccountAdminForm',
  data() {
    return {
      form: {
        address: {
          address_line1: null,
          address_line2: null,
          city: null,
          state: null,
          zip: null
        },
        dietaryRequirements: null
      },
      avatar: {},
      newParents: [],
      newGroups: [],
      states: [],
      selectedNutritionist: null,
      selectedState: null,
      isSending: false
    }
  },
  props: ['user', 'isAdmin', 'forClient', 'myAccount'],
  components: { ParentFormBasic, UserAccountGroupForm },
  methods: {
    ...mapActions(['getStates', 'getNutritionists', 'getGroups']),
    handleRemove(index) {
      this.form.parents.splice(index, 1)
    },
    handleSave() {
      this.isSending = true
      this.$emit('handleSave', this.dataToSave)
    },
    handleGroupAdd(group) {
      const contains = this.newGroups.some(g => g._id === group._id)
      if (!contains) {
        this.newGroups.push(group)
      }
    },
    handleGroupRemove(group) {
      this.newGroups = this.newGroups.filter(g => g._id !== group._id)
    },
    addParent() {
      this.newParents.push({
        firstName: null,
        lastName: null,
        email: null,
        phone: null
      })
    },
    changedAvatar() {
      let avatarData = this.avatar.generateDataUrl()
      if (avatarData !== '' && avatarData !== this.form.profilePic) {
        this.form.profilePic = this.avatar.generateDataUrl()
      }
    }
  },
  computed: {
    ...mapGetters(['dietitians', 'groups']),
    displayParents() {
      return this.form.parents && this.form.parents.length > 0
    },
    dataToSave() {
      const parents = this.newParents.filter(p => Object.values(p).every(x => x !== null && x !== ''))
      this.form.parents.push(...parents)
      this.form.newGroups = this.newGroups
      this.form.nutritionist = this.selectedNutritionist
      this.form.address.state = this.selectedState
      if (this.form.DOB) this.form.DOB = new Date(this.form.DOB).toISOString()
      return this.form
    },
    displayNutritionist() {
      return this.forClient && this.isAdmin
    }
  },
  mounted: async function () {
    const clone = this.user
    if (!clone.address) clone.address = this.form
    if (!clone.parents) clone.parents = []
    if (this.user.DOB) {
      const utc = this.user.DOB
      const time = utc.substring(0, utc.length - 1)
      clone.DOB = moment(time).format('yyyy-MM-DD')
    }

    await this.getGroups({})
    this.form = clone
    this.form.newParents = []
    this.newGroups = clone.groups
    this.states = await this.getStates()
    if (clone.nutritionist) this.selectedNutritionist = clone.nutritionist._id
    if (clone.address.state) this.selectedState = clone.address.state
    await this.getNutritionists({})
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/UserAccount/UserAccountAdminForm.vue?0bd565df